import { useEffect } from "react";
import { useAtom } from "jotai";
import { progressAtom } from "../../utils/atoms/progressAtom";
import { Modal, Button } from "react-bootstrap";
import "./customModal.css";
import MGAAPI from "../../api";
import displayError from "../../constants/utils";
import { projectDetailsAtom } from "../../utils/atoms/projectDetailsAtom";
import { useAssessmentRouteParams } from "../../constants/helper";

const MGA_API = new MGAAPI();

const CircularTimer = () => {
  const [progressList, setProgressList] = useAtom(progressAtom);
  const [projectDetails] = useAtom(projectDetailsAtom);
  const { designId, designVersionId, projectId } = useAssessmentRouteParams();

  const simulationStatus = () => {
    // const projectDesignVersion =
    //   projectDetails?.designWithVersionsDTOList?.[0]?.designVersionDTO?.[0];
    // const { designId, designVersionId, projectId } = projectDesignVersion;

    MGA_API.simulationStatus(projectId, designId, designVersionId)
      .then((res) => {
        if (res.Status === "READY") {
          setProgressList({
            status: false,
            timeLeft: 0,
          });
          displayError("success", "Simulation Status Updated");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        displayError("error", "Error while running Simulation");
      });
  };
  useEffect(() => {
    if (!progressList.status) return;

    const interval = setInterval(() => {
      let timestak = 0;
      setProgressList((prev) => {
        if (prev.timeLeft <= 1) {
          clearInterval(interval);
          timestak = prev.timeLeft;
          return { ...prev, timeLeft: 0 };
        }
        timestak = prev.timeLeft - 1;
        return { ...prev, timeLeft: prev.timeLeft - 1 };
      });
      if (timestak % 30 === 0) {
        simulationStatus();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [progressList.status, setProgressList]);

  const percentage = (progressList.timeLeft / 120) * 100;
  const displayTime = `${Math.floor(progressList.timeLeft / 60)}:${String(
    progressList.timeLeft % 60
  ).padStart(2, "0")}`;

  return (
    <Modal
      size="sm"
      show={progressList.status}
      centered
      className="custom-modal"
    >
      <Modal.Body className="d-flex justify-content-center">
        <div className="position-relative d-inline-flex">
          <svg width="350" height="350" viewBox="0 0 100 100">
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="#32AD3C"
              strokeWidth="7"
              fill="none"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="lightgrey"
              strokeWidth="7"
              fill="none"
              strokeDasharray={`${2 * Math.PI * 45}`}
              strokeDashoffset={`${(percentage / 100) * 2 * Math.PI * 45}`}
              transform="rotate(-90 50 50)"
            />
          </svg>

          <div className="position-absolute w-100 h-100 d-flex align-items-center flex-column justify-content-center">
            <span
              style={{
                fontFamily: "Nunito",
                color: "#42B4E6",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              Simulation In Progress
            </span>
            <span
              style={{
                fontFamily: "Nunito",
                fontWeight: "700",
                fontSize: "56px",
              }}
            >
              {displayTime}
            </span>
            <span
              style={{ fontFamily: "Nunito", color: "black", fontSize: "14px" }}
            >
              Verifying the Load...
            </span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          aria-label="simulation-progress-close"
          variant="secondary"
          onClick={() => setProgressList({ status: false, timeLeft: 0 })}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CircularTimer;
